import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledBeginSearchIllustration = styled.svg`
  --color-white: ${({ theme }) => theme.color.additional.light.value};
  --color-gray-50: ${({ theme }) => theme.color.gray[50].value};
  --color-gray-300: ${({ theme }) => theme.color.gray[300].value};
`;

const BeginSearchIllustration = ({ className, dataTestId, size = 991, svgTitle = 'Begin Search', ...other }) => {
  return (
    <StyledBeginSearchIllustration
      className={className}
      data-testid={dataTestId ? `${dataTestId}-begin-search` : 'begin-search-svg'}
      width={size}
      height={Math.round(size * 0.4036327)}
      viewBox="0 0 991 408"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      {svgTitle && <title>{svgTitle}</title>}
      <path
        className="background-half-circle"
        d="M804.644 333.288H181.766C181.766 333.288 194.098 0 497.461 0C795.882 0 804.644 333.288 804.644 333.288Z"
        fill="var(--color-gray-50)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.506 58.7509V62.0453H162.8V58.7509H159.506Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.798 58.7509V61.4962H137.543V58.7509H134.798Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.798 84.8318V87.8518H137.818V84.8318H134.798Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.717 84.8318V87.8518H111.736V84.8318H108.717Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.3815 84.8318H83.459V86.7543H85.3815V84.8318Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.026 111.187H57.1035V113.11H59.026V111.187Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.3815 111.187H83.459V113.11H85.3815V111.187Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.089 112.011H109.815V112.286H110.089V112.011ZM107.893 110.089V114.207H112.011V110.089H107.893Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.1062 162.8H83.7335V164.173H85.1062V162.8ZM81.8118 160.879V166.095H87.028V160.879H81.8118Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.462 161.153H108.442V164.173H111.462V161.153ZM106.52 159.231V166.095H113.384V159.231H106.52Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.092 161.153H133.15V166.095H138.092V161.153ZM131.229 159.231V168.016H140.014V159.231H131.229Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.447 161.153H159.506V166.095H164.447V161.153ZM157.584 159.231V168.016H166.369V159.231H157.584Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M267.399 160.329H260.261V167.467H267.399V160.329ZM258.339 158.408V169.389H269.321V158.408H258.339Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M292.381 159.78H284.694V167.467H292.381V159.78ZM282.773 157.859V169.389H294.303V157.859H282.773Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M319.561 159.231H311.325V167.467H319.561V159.231ZM309.403 157.31V169.389H321.482V157.31H309.403Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.191 158.133H336.033V168.291H346.191V158.133ZM334.111 156.211V170.213H348.113V156.211H334.111Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.191 183.94H336.033V194.097H346.191V183.94ZM334.111 182.018V196.019H348.113V182.018H334.111Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M626.493 183.94H616.335V194.097H626.493V183.94ZM614.413 182.018V196.019H628.414V182.018H614.413Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M651.201 185.312H643.789V192.725H651.201V185.312ZM641.867 183.391V194.647H653.123V183.391H641.867Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M675.909 186.41H670.968V191.352H675.909V186.41ZM669.046 184.489V193.274H677.831V184.489H669.046Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M752.78 185.861H747.564V191.078H752.78V185.861ZM745.642 183.94V192.999H754.702V183.94H745.642Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M727.797 185.861H721.757V191.901H727.797V185.861ZM719.835 183.94V193.823H729.719V183.94H719.835Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M829.375 186.685H824.983V191.078H829.375V186.685ZM823.061 184.763V192.999H831.297V184.763H823.061Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M905.148 187.509H901.853V190.803H905.148V187.509ZM899.932 185.587V192.725H907.07V185.587H899.932Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M930.13 188.332H928.483V189.979H930.13V188.332ZM926.561 186.41V191.901H932.052V186.41H926.561Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M952.917 187.234V191.078H956.761V187.234H952.917Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M293.754 183.94H283.597V194.097H293.754V183.94ZM281.675 182.018V196.019H295.676V182.018H281.675Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.046 183.94H258.888V194.097H269.046V183.94ZM256.966 182.018V196.019H270.968V182.018H256.966Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242.965 183.94H233.63V193.274H242.965V183.94ZM231.709 182.018V195.196H244.887V182.018H231.709Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.982 183.94H208.648V193.274H217.982V183.94ZM206.726 182.018V195.196H219.904V182.018H206.726Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190.803 184.489H182.567V192.725H190.803V184.489ZM180.645 182.567V194.647H192.725V182.567H180.645Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.722 185.587H157.859V192.45H164.722V185.587ZM155.937 183.665V194.372H166.644V183.665H155.937Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.641 185.587H132.327V191.901H138.641V185.587ZM130.405 183.665V193.823H140.563V183.665H130.405Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.109 185.587H106.795V191.901H113.109V185.587ZM104.873 183.665V193.823H115.031V183.665H104.873Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.2046 186.96H82.6356V190.529H86.2046V186.96ZM80.7139 185.038V192.45H88.1264V185.038H80.7139Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.748 187.234V190.803H34.317V187.234H30.748Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0425 214.139H32.6698V215.511H34.0425V214.139ZM30.748 212.217V217.433H35.9642V212.217H30.748Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0425 239.396H32.6698V240.769H34.0425V239.396ZM30.748 237.474V242.69H35.9642V237.474H30.748Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0425 265.477H32.6698V266.85H34.0425V265.477ZM30.748 263.555V268.771H35.9642V263.555H30.748Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0425 290.734H32.6698V292.107H34.0425V290.734ZM30.748 288.813V294.029H35.9642V288.813H30.748Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.0425 316.815H32.6698V318.188H34.0425V316.815ZM30.748 314.894V320.11H35.9642V314.894H30.748Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.947 212.766H56.829V216.884H60.947V212.766ZM54.9072 210.844V218.806H62.8688V210.844H54.9072Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.7708 237.2H56.0055V242.965H61.7708V237.2ZM54.0837 235.278V244.887H63.6925V235.278H54.0837Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.7708 263.281H56.0055V269.046H61.7708V263.281ZM54.0837 261.359V270.968H63.6925V261.359H54.0837Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.7708 288.538H56.0055V294.303H61.7708V288.538ZM54.0837 286.616V296.225H63.6925V286.616H54.0837Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.7534 212.217H82.0863V216.884H86.7534V212.217ZM80.1646 210.295V218.806H88.6752V210.295H80.1646Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.5774 288.264H81.2631V294.578H87.5774V288.264ZM79.3413 286.342V296.5H89.4992V286.342H79.3413Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.1262 313.521H80.7137V320.933H88.1262V313.521ZM78.792 311.599V322.855H90.048V311.599H78.792Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.384 313.796H106.795V320.384H113.384V313.796ZM104.873 311.874V322.306H115.305V311.874H104.873Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.563 312.148H130.954V321.757H140.563V312.148ZM129.032 310.227V323.679H142.485V310.227H129.032Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.369 311.599H155.662V322.306H166.369V311.599ZM153.74 309.677V324.228H168.291V309.677H153.74Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.384 211.119H106.795V217.708H113.384V211.119ZM104.873 209.197V219.629H115.305V209.197H104.873Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.739 210.57H131.503V218.806H139.739V210.57ZM129.581 208.648V220.728H141.661V208.648H129.581Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.739 235.278H131.503V243.514H139.739V235.278ZM129.581 233.356V245.436H141.661V233.356H129.581Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.288 261.084H131.229V270.144H140.288V261.084ZM129.307 259.163V272.066H142.21V259.163H129.307Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.563 286.616H130.68V296.5H140.563V286.616ZM128.758 284.695V298.421H142.485V284.695H128.758Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.82 210.021H156.486V219.355H165.82V210.021ZM154.564 208.099V221.277H167.742V208.099H154.564Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.369 235.278H156.211V245.436H166.369V235.278ZM154.29 233.356V247.358H168.291V233.356H154.29Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.901 235.278H181.743V245.436H191.901V235.278ZM179.822 233.356V247.358H193.823V233.356H179.822Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.901 259.986H181.743V270.144H191.901V259.986ZM179.822 258.065V272.066H193.823V258.065H179.822Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.901 286.342H181.743V296.5H191.901V286.342ZM179.822 284.42V298.421H193.823V284.42H179.822Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.531 235.003H207.55V245.985H218.531V235.003ZM205.628 233.082V247.907H220.453V233.082H205.628Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.531 259.986H207.55V270.968H218.531V259.986ZM205.628 258.065V272.89H220.453V258.065H205.628Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M244.612 259.437H231.434V272.615H244.612V259.437ZM229.513 257.515V274.537H246.534V257.515H229.513Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.144 259.437H256.966V272.615H270.144V259.437ZM255.045 257.515V274.537H272.066V257.515H255.045Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M295.127 259.437H281.949V272.615H295.127V259.437ZM280.027 257.515V274.537H297.049V257.515H280.027Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M244.612 284.969H231.434V298.147H244.612V284.969ZM229.513 283.047V300.069H246.534V283.047H229.513Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.419 284.969H257.241V298.147H270.419V284.969ZM255.319 283.047V300.069H272.341V283.047H255.319Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M243.789 310.776H231.434V323.13H243.789V310.776ZM229.513 308.854V325.052H245.71V308.854H229.513Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.531 286.067H207.55V297.049H218.531V286.067ZM205.628 284.146V298.97H220.453V284.146H205.628Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.531 311.325H207.55V322.306H218.531V311.325ZM205.628 309.403V324.228H220.453V309.403H205.628Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.144 234.18H257.516V246.809H270.144V234.18ZM255.594 232.258V248.73H272.066V232.258H255.594Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M296.774 233.631H283.047V247.358H296.774V233.631ZM281.125 231.709V249.279H298.696V231.709H281.125Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M321.757 233.631H308.03V247.358H321.757V233.631ZM306.108 231.709V249.279H323.679V231.709H306.108Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M347.838 233.631H334.111V247.358H347.838V233.631ZM332.189 231.709V249.279H349.76V231.709H332.189Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.369 259.986H156.211V270.144H166.369V259.986ZM154.29 258.065V272.066H168.291V258.065H154.29Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.708 209.472H207.275V219.904H217.708V209.472ZM205.354 207.55V221.826H219.629V207.55H205.354Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M243.788 208.648H231.983V220.728H243.788V208.648ZM230.062 206.726V222.649H245.71V206.726H230.062Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M295.127 208.373H283.047V221.002H295.127V208.373ZM281.125 206.452V222.924H297.049V206.452H281.125Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M321.208 207.824H308.03V221.551H321.208V207.824ZM306.108 205.903V223.473H323.13V205.903H306.108Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M348.936 207.001H334.111V222.375H348.936V207.001ZM332.189 205.079V224.296H350.858V205.079H332.189Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M655.045 207.001H640.22V222.375H655.045V207.001ZM638.298 205.079V224.296H656.966V205.079H638.298Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M706.109 233.356H691.284V248.73H706.109V233.356ZM689.362 231.434V250.652H708.03V231.434H689.362Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M731.64 258.339H717.364V273.164H731.64V258.339ZM715.443 256.417V275.086H733.562V256.417H715.443Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M731.64 284.42H717.364V299.245H731.64V284.42ZM715.443 282.498V301.167H733.562V282.498H715.443Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M731.64 309.128H717.364V323.953H731.64V309.128ZM715.443 307.207V325.875H733.562V307.207H715.443Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M756.349 259.163H743.445V272.34H756.349V259.163ZM741.524 257.241V274.262H758.27V257.241H741.524Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M806.04 235.552H796.431V245.436H806.04V235.552ZM794.509 233.631V247.358H807.962V233.631H794.509Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M831.023 236.376H822.787V244.612H831.023V236.376ZM820.865 234.454V246.534H832.944V234.454H820.865Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M831.023 261.359H822.787V269.595H831.023V261.359ZM820.865 259.437V271.517H832.944V259.437H820.865Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M831.572 286.342H822.787V295.127H831.572V286.342ZM820.865 284.42V297.049H833.493V284.42H820.865Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M807.138 259.986H796.431V270.968H807.138V259.986ZM794.509 258.065V272.89H809.06V258.065H794.509Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M807.138 286.342H796.431V297.323H807.138V286.342ZM794.509 284.42V299.245H809.06V284.42H794.509Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M756.349 284.42H743.445V297.598H756.349V284.42ZM741.524 282.498V299.52H758.27V282.498H741.524Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M756.349 310.501H743.445V323.679H756.349V310.501ZM741.524 308.579V325.601H758.27V308.579H741.524Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M730.268 233.905H717.364V247.083H730.268V233.905ZM715.443 231.984V249.005H732.189V231.984H715.443Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M679.204 208.648H667.673V220.728H679.204V208.648ZM665.751 206.726V222.649H681.126V206.726H665.751Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M705.01 208.648H693.48V220.728H705.01V208.648ZM691.558 206.726V222.649H706.932V206.726H691.558Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M730.268 208.648H718.737V220.728H730.268V208.648ZM716.815 206.726V222.649H732.189V206.726H716.815Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M754.976 209.746H745.367V219.629H754.976V209.746ZM743.446 207.824V221.551H756.898V207.824H743.446Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M779.684 210.57H771.448V218.806H779.684V210.57ZM769.526 208.648V220.728H781.606V208.648H769.526Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M781.606 311.05H769.801V322.855H781.606V311.05ZM767.879 309.128V324.777H783.528V309.128H767.879Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M805.765 210.57H797.529V218.806H805.765V210.57ZM795.607 208.648V220.728H807.687V208.648H795.607Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M855.731 211.393H849.142V217.982H855.731V211.393ZM847.22 209.471V219.904H857.653V209.471H847.22Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M855.731 237.2H849.142V243.789H855.731V237.2ZM847.22 235.278V245.71H857.653V235.278H847.22Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M881.537 237.474H875.497V243.514H881.537V237.474ZM873.576 235.552V245.436H883.459V235.552H873.576Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M906.795 263.555H901.853V268.497H906.795V263.555ZM899.932 261.634V270.419H908.717V261.634H899.932Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M906.795 288.813H901.853V293.754H906.795V288.813ZM899.932 286.891V295.676H908.717V286.891H899.932Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M906.795 314.07H901.853V319.012H906.795V314.07ZM899.932 312.148V320.933H908.717V312.148H899.932Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M881.537 262.457H875.497V268.497H881.537V262.457ZM873.576 260.535V270.419H883.459V260.535H873.576Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M881.537 287.714H875.497V293.754H881.537V287.714ZM873.576 285.793V295.676H883.459V285.793H873.576Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M881.537 314.07H875.497V320.11H881.537V314.07ZM873.576 312.148V322.032H883.459V312.148H873.576Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M855.731 262.183H849.142V268.772H855.731V262.183ZM847.22 260.261V270.693H857.653V260.261H847.22Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M880.439 212.217H875.497V217.159H880.439V212.217ZM873.576 210.295V219.08H882.361V210.295H873.576Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M905.148 213.04H901.853V216.335H905.148V213.04ZM899.932 211.119V218.257H907.07V211.119H899.932Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M931.503 213.04H928.209V216.335H931.503V213.04ZM926.287 211.119V218.257H933.425V211.119H926.287Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M931.503 238.847H928.209V242.141H931.503V238.847ZM926.287 236.925V244.063H933.425V236.925H926.287Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M931.503 289.636H928.209V292.931H931.503V289.636ZM926.287 287.714V294.852H933.425V287.714H926.287Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M931.503 315.443H928.209V318.737H931.503V315.443ZM926.287 313.521V320.659H933.425V313.521H926.287Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M956.486 213.864H954.839V215.511H956.486V213.864ZM952.917 211.942V217.433H958.408V211.942H952.917Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M956.486 264.379H954.839V266.026H956.486V264.379ZM952.917 262.457V267.948H958.408V262.457H952.917Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M956.486 239.671H954.839V241.318H956.486V239.671ZM952.917 237.749V243.24H958.408V237.749H952.917Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M956.486 290.185H954.839V291.833H956.486V290.185ZM952.917 288.264V293.754H958.408V288.264H952.917Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M956.486 315.992H954.839V317.639H956.486V315.992ZM952.917 314.07V319.561H958.408V314.07H952.917Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M990.94 335.484H0V333.562H990.94V335.484Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.1062 136.445H83.7335V137.817H85.1062V136.445ZM81.8118 134.523V139.739H87.028V134.523H81.8118Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.43 134.798H184.214V140.014H189.43V134.798ZM182.292 132.876V141.935H191.352V132.876H182.292Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M318.188 134.248H311.05V141.386H318.188V134.248ZM309.128 132.327V143.308H320.11V132.327H309.128Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M344.544 133.699H336.307V141.935H344.544V133.699ZM334.386 131.778V143.857H346.465V131.778H334.386Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M370.35 133.699H362.114V141.935H370.35V133.699ZM360.192 131.778V143.857H372.272V131.778H360.192Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M395.882 133.699H387.646V141.935H395.882V133.699ZM385.724 131.778V143.857H397.804V131.778H385.724Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M420.316 135.072H415.099V140.288H420.316V135.072ZM413.178 133.15V142.21H422.237V133.15H413.178Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M445.573 135.072H440.357V140.288H445.573V135.072ZM438.435 133.15V142.21H447.495V133.15H438.435Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M595.196 136.17V139.465H598.49V136.17H595.196Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M623.198 162.8H621.826V164.173H623.198V162.8ZM619.904 160.879V166.095H625.12V160.879H619.904Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M649.279 161.428H646.534V164.173H649.279V161.428ZM644.612 159.506V166.095H651.201V159.506H644.612Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M673.988 162.8H672.615V164.173H673.988V162.8ZM670.693 160.879V166.095H675.909V160.879H670.693Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M699.52 163.349H699.245V163.624H699.52V163.349ZM697.323 161.428V165.546H701.441V161.428H697.323Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M725.326 162.8H723.953V164.173H725.326V162.8ZM722.032 160.879V166.095H727.248V160.879H722.032Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M751.132 162.8H749.76V164.173H751.132V162.8ZM747.838 160.879V166.095H753.054V160.879H747.838Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M776.39 162.8H775.017V164.173H776.39V162.8ZM773.095 160.879V166.095H778.311V160.879H773.095Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M802.745 161.428H800V164.173H802.745V161.428ZM798.078 159.506V166.095H804.667V159.506H798.078Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M827.454 162.8H826.081V164.173H827.454V162.8ZM824.159 160.879V166.095H829.375V160.879H824.159Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M854.084 162.8H852.711V164.173H854.084V162.8ZM850.789 160.879V166.095H856.006V160.879H850.789Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M880.165 161.153H877.145V164.173H880.165V161.153ZM875.223 159.231V166.095H882.087V159.231H875.223Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M901.853 160.879V164.448H905.422V160.879H901.853Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M929.856 162.8H928.483V164.173H929.856V162.8ZM926.561 160.879V166.095H931.777V160.879H926.561Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M620.728 136.17V138.642H623.199V136.17H620.728Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M748.387 136.17V139.739H751.956V136.17H748.387Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M825.807 136.17V139.739H829.376V136.17H825.807Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M853.26 136.994H852.437V137.817H853.26V136.994ZM850.515 135.072V139.739H855.182V135.072H850.515Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M878.517 136.719H877.419V137.817H878.517V136.719ZM875.498 134.798V139.739H880.439V134.798H875.498Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M904.873 137.543H904.599V137.817H904.873V137.543ZM902.677 135.621V139.739H906.795V135.621H902.677Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M929.856 137.543H929.581V137.817H929.856V137.543ZM927.66 135.621V139.739H931.778V135.621H927.66Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.1035 136.17V139.739H60.6725V136.17H57.1035Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.8 110.364H159.231V113.933H162.8V110.364ZM157.31 108.442V115.855H164.722V108.442H157.31Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.607 110.364H185.038V113.933H188.607V110.364ZM183.116 108.442V115.855H190.528V108.442H183.116Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.413 110.364H210.844V113.933H214.413V110.364ZM208.923 108.442V115.855H216.335V108.442H208.923Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M240.219 110.364H236.651V113.933H240.219V110.364ZM234.729 108.442V115.855H242.141V108.442H234.729Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.026 110.364H261.634V114.756H266.026V110.364ZM259.712 108.442V116.678H267.948V108.442H259.712Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M291.284 110.364H286.891V114.756H291.284V110.364ZM284.969 108.442V116.678H293.205V108.442H284.969Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M317.364 110.364H312.972V114.756H317.364V110.364ZM311.05 108.442V116.678H319.286V108.442H311.05Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.622 110.364H339.602V113.384H342.622V110.364ZM337.68 108.442V115.305H344.544V108.442H337.68Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M367.33 110.364H364.31V113.384H367.33V110.364ZM362.388 108.442V115.305H369.252V108.442H362.388Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M393.411 110.364H389.018V114.756H393.411V110.364ZM387.097 108.442V116.678H395.333V108.442H387.097Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M420.316 109.815H415.099V115.031H420.316V109.815ZM413.178 107.893V116.953H422.237V107.893H413.178Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M443.102 111.736H441.729V113.109H443.102V111.736ZM439.808 109.815V115.031H445.024V109.815H439.808Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M469.458 111.736H468.085V113.109H469.458V111.736ZM466.164 109.815V115.031H471.38V109.815H466.164Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.1035 86.2051H58.4767V84.8318H57.1035V86.2051Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.231 84.5573V88.1263H162.8V84.5573H159.231Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186.959 86.2045H186.685V86.4791H186.959V86.2045ZM184.763 84.2828V88.4008H188.881V84.2828H184.763Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.864 85.1064H212.491V86.4791H213.864V85.1064ZM210.57 83.1846V88.4008H215.786V83.1846H210.57Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M240.494 85.1064H237.2V88.4008H240.494V85.1064ZM235.278 83.1846V90.3226H242.416V83.1846H235.278Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.203 85.1064H261.908V88.4008H265.203V85.1064ZM259.986 83.1846V90.3226H267.124V83.1846H259.986Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M289.911 85.1064H288.264V86.7536H289.911V85.1064ZM286.342 83.1846V88.6754H291.833V83.1846H286.342Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M316.266 85.1064H314.894V86.4791H316.266V85.1064ZM312.972 83.1846V88.4008H318.188V83.1846H312.972Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M340.7 86.2045H340.426V86.4791H340.7V86.2045ZM338.504 84.2828V88.4008H342.622V84.2828H338.504Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M364.036 84.8318V88.4008H367.605V84.8318H364.036Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M389.568 84.8318V88.4008H393.137V84.8318H389.568Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M415.648 84.8318V88.4008H419.217V84.8318H415.648Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M467.811 84.8318V87.029H470.008V84.8318H467.811Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M493.068 86.2051H494.441V84.8318H493.068V86.2051Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M187.234 60.6726H186.136V61.7708H187.234V60.6726ZM184.214 58.7509V63.6925H189.156V58.7509H184.214Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.315 60.6726H212.217V61.7708H213.315V60.6726ZM210.295 58.7509V63.6925H215.237V58.7509H210.295Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M238.298 60.6726H237.2V61.7708H238.298V60.6726ZM235.278 58.7509V63.6925H240.22V58.7509H235.278Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M264.653 60.6726H263.555V61.7708H264.653V60.6726ZM261.634 58.7509V63.6925H266.575V58.7509H261.634Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M289.362 60.6726H288.264V61.7708H289.362V60.6726ZM286.342 58.7509V63.6925H291.283V58.7509H286.342Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M316.266 60.6726H315.168V61.7708H316.266V60.6726ZM313.246 58.7509V63.6925H318.188V58.7509H313.246Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M364.859 59.5745V62.0463H367.331V59.5745H364.859Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M390.666 59.849V62.0461H392.863V59.849H390.666Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M418.395 60.1236H416.472V62.0461H418.395V60.1236Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M441.73 62.0459H443.378V60.3981H441.73V62.0459Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M468.085 62.0457H469.184V60.9471H468.085V62.0457Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.844 34.0425V37.0624H213.864V34.0425H210.844Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M237.2 34.0425V37.0624H240.22V34.0425H237.2Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M262.182 34.0425V37.0624H265.202V34.0425H262.182Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M288.264 34.0425V37.0624H291.284V34.0425H288.264Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M313.246 34.0425V37.0624H316.266V34.0425H313.246Z"
        fill="var(--color-gray-300)"
      />
      <path
        className="background-squares"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M339.327 34.0425V37.0624H342.347V34.0425H339.327Z"
        fill="var(--color-gray-300)"
      />

      <g filter="url(#filter0_d_12143_50043)">
        <path
          className="cloud"
          d="M619.655 400H347.598C265.717 400 228.739 258.196 343.196 235.296C330.87 207.992 354.642 129.604 439.164 157.789C506.959 58.2617 625.819 130.485 619.655 207.992C757.005 215.919 741.157 400 619.655 400Z"
          fill="var(--color-white)"
        />
      </g>
      <path
        className="magnifying-glass"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M484.25 219.904C455.004 219.904 431.297 243.604 431.297 272.837C431.297 302.07 455.004 325.77 484.25 325.77C513.495 325.77 537.202 302.07 537.202 272.837C537.202 243.604 513.495 219.904 484.25 219.904ZM425.257 272.837C425.257 240.266 451.67 213.864 484.25 213.864C516.829 213.864 543.242 240.266 543.242 272.837C543.242 287.284 538.045 300.518 529.418 310.772L577.229 358.83L572.947 363.09L525.297 315.193C514.678 325.479 500.203 331.81 484.25 331.81C451.67 331.81 425.257 305.408 425.257 272.837Z"
        fill="var(--color-gray-300)"
      />
      <defs>
        <filter
          id="filter0_d_12143_50043"
          x="270.968"
          y="109.266"
          width="453.848"
          height="298.734"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12143_50043" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12143_50043" result="shape" />
        </filter>
      </defs>
    </StyledBeginSearchIllustration>
  );
};

BeginSearchIllustration.propTypes = {
  /** Adds additional class to the component */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** Adjusts the size of the svg based upon the width. The aspect ratio is locked. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Adds SVG accessibility title element */
  svgTitle: PropTypes.string,
};

export { BeginSearchIllustration };
